export default "__VITE_ASSET__C$uc8C0S__"